import { getLastestFenceEvent } from '../Components/Map/Helpers';
import { AssetEntity, FenceEvent } from '../util/enums';
import { AssetUpdateType, Notification } from '../util/Events/Messages';
import { AssetCoordinatesTriggered } from '../util/Events/schema';

export const DisplayMessage = (notifiction: Notification): string => {
  const asset = notifiction.asset;
  if (notifiction.updateType === AssetUpdateType.SensedTriggered && asset.lastSensedTriggered) {
    const event = (
      asset.lastSensedTriggered.entered ? FenceEvent.Entered : FenceEvent.Exited
    ).toLowerCase();
    const sensedAsset = asset.lastSensedTriggered.sensedIds;
    const sensedTriggered = asset.lastSensedTriggered.microfence;
    return `Asset ${sensedAsset.label} ${event} Microfence: ${
      sensedTriggered?.label ?? AssetEntity.Unknown
    }`;
  } else {
    const lastFenceEvent = getLastestFenceEvent(asset) as AssetCoordinatesTriggered;
    const event = (lastFenceEvent.entered ? FenceEvent.Entered : FenceEvent.Exited).toLowerCase();
    const fenceTriggered = lastFenceEvent.fenceIds;
    return `Asset ${asset.label} ${event} Geofence: ${
      fenceTriggered?.label ?? AssetEntity.Unknown
    }`;
  }
};
